<div v-if="isActive" @keydown.stop class="modal-container">
  <div @click="overLayClick" class="overlay"></div>
  <div :class="modalSize">
    <div :class="headerClass" class="modal-header">
      <slot name="title">
        <b class="capitalization">{{ $t(labelText) }}</b>
      </slot>
      <i @click="onClose" class="fa fa-times go-right p3 pointer"></i>
    </div>
    <div :class="contentClass" class="modal-body">
      <div v-if="message" class="text-default text-message">
        <i class="fa fa-exclamation-triangle mr5"></i>
        {{ $t(message) }}
      </div>
      <div v-else-if="!isText && !custom" class="text-default text-message">
        <i class="fa fa-exclamation-triangle mr5"></i>
        {{ $t(text) }}
      </div>
      <slot name="modal" :row="payloads"></slot>
    </div>
    <div
      v-if="isAction"
      :class="footerClass"
      class="modal-footer txt-right"
    >
      <div class="flex" style="justify-content: end">
        <slot name="action" :row="actions"></slot>
        <span
          v-if="cancel"
          @click="onClose"
          class="btn btn-secondary capitalization pl15 pr15 btn-padding btn-default-setting"
          >{{ $t(cancel) }}</span
        >
        <c-button
          v-if="confirm"
          @handler="onConfirm"
          :isLoading="isLoading"
          class="btn btn-primary ml6 capitalization pl15 pr15 btn-padding btn-keypress"
          :value="confirm"
          type="span"
        ></c-button>
      </div>
    </div>
  </div>
</div>
